import { Translate } from '@chipinside/translate'
import { lowerFirst } from 'lodash'

import {
  ImportInstructionsConfig,
  SpreadsheetNameKey,
} from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

interface IParams {
  instructions: ImportInstructionsConfig
  spreadsheetType?: string
}

export const buildSoftwareInstructions = ({ instructions, spreadsheetType }: IParams) => {
  const { dateInstructionByType, dateInstructionKey, software } = instructions

  /**
   * Verifica se existe type definido e se existe uma instrução específica para esse type
   * caso contrário, utiliza a instrução genérica.
   */
  const spreadsheetNameConfig =
    (spreadsheetType && instructions.spreadsheetNameByType?.[spreadsheetType]) ||
    instructions.spreadsheetName

  const spreadsheetName = spreadsheetNameConfig ? resolveSpreadsheetName(spreadsheetNameConfig) : ''

  /**
   * Tenta pegar a instrução específica para o type, caso exista, senão utiliza a instrução genérica.
   * Hj é utilizada na Ideagri para mostrar uma instrução diferente dependendo do tipo da planilha selecionada
   */
  const dateInstructionResolvedKey =
    (spreadsheetType && dateInstructionByType?.[spreadsheetType]) || dateInstructionKey

  return [
    {
      label:
        spreadsheetName &&
        Translate({
          messageKey: 'software_download_spreadsheet',
          params: { software, spreadsheetName },
        }),
    },
    {
      label: dateInstructionResolvedKey
        ? Translate({ messageKey: dateInstructionResolvedKey })
        : '',
    },
    {
      label: Translate({
        messageKey: instructions.fileInstructionKey ?? 'select_exported_file',
        params: { software: software },
      }),
    },
    {
      label: Translate({ messageKey: 'import_will_be_notified' }),
    },
  ].filter(item => item.label)
}

/**
 * Resolve o nome da planilha a partir da configuração, que pode ser uma string ou um objeto de tradução.
 * Se for um objeto de tradução, utiliza a função Translate para obter o nome traduzido, aplicando lowerFirst se necessário.
 */
const resolveSpreadsheetName = (spreadsheetName: SpreadsheetNameKey) => {
  const { lowerFirst: shouldLowerFirst, ...translateProps } = spreadsheetName

  if (Array.isArray(translateProps.messageKey)) {
    return Translate({
      separator: ' - ',
      ...translateProps,
    } as never)
  }

  const translated = Translate(translateProps as never)

  return shouldLowerFirst ? lowerFirst(translated) : translated
}
